type ClientIdValue = string | number | null | undefined;

type ClientIdRecord = {
  client_id?: ClientIdValue;
  clientId?: ClientIdValue;
  client?: { id?: ClientIdValue } | null;
  account?: ClientIdRecord | null;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function normalizeUserEventClientId(value: unknown): string | null {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return `${value}`;
  }

  return null;
}

function readClientIdFromRecord(context: unknown): string | null {
  if (!isRecord(context)) return null;

  const candidate = context as ClientIdRecord;
  return (
    normalizeUserEventClientId(candidate.client_id) ??
    normalizeUserEventClientId(candidate.clientId) ??
    normalizeUserEventClientId(candidate.client?.id) ??
    readClientIdFromRecord(candidate.account)
  );
}

export function resolveUserEventClientId(...contexts: unknown[]): string | null {
  for (const context of contexts) {
    const clientId =
      normalizeUserEventClientId(context) ?? readClientIdFromRecord(context);
    if (clientId) return clientId;
  }

  return null;
}
